function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var MovementOverlayTemplate = require('./movement.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var MovementOverlay = /*#__PURE__*/function () {
  function MovementOverlay(app, mod) {
    _classCallCheck(this, MovementOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
    this.fade_out_available_units = false;
    this.mobj = null;
    this.selectUnitsInterface = null;
    this.selectDestinationInterface = null;
  }
  return _createClass(MovementOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
      return;
    }
  }, {
    key: "renderForceOpen",
    value: function renderForceOpen(mobj, units_to_move) {
      var selectUnitsInterface = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var selectDestinationInterface = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      this.render(mobj, units_to_move, selectUnitsInterface, selectDestinationInterface, true);
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "render",
    value: function render(mobj) {
      var units_to_move = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var selectUnitsInterface = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var selectDestinationInterface = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var force_open = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      if (force_open == false) {
        this.overlay.closebox = false;
        this.overlay.clickToClose = false;
        this.overlay.clickBackdropToClose = false;
      } else {
        this.overlay.closebox = true;
        this.overlay.clickToClose = false;
        this.overlay.clickBackdropToClose = true;
      }
      var his_self = this.mod;
      var space = mobj.space;
      this.mobj = mobj;
      this.selectUnitsInterface = selectUnitsInterface;
      this.selectDestinationInterface = selectDestinationInterface;
      var faction = mobj.faction;
      var source = mobj.source;
      var destination = mobj.destination;
      var max_formation_size = this.mod.returnMaxFormationSize(units_to_move, faction, source);
      var units = space.units[faction];
      var from = this.mod.game.spaces[source].name;
      var to = '';
      if (destination === '') {
        destination = '?';
      } else {
        to = this.mod.game.spaces[destination].name;
      }
      if (!mobj.unmoved_units) {
        mobj.unmoved_units = [];
      }
      if (!mobj.moved_units) {
        mobj.moved_units = [];
      }

      //
      // create list of figures in each space
      //
      var moved_units = mobj.moved_units;
      var unmoved_units = mobj.unmoved_units;
      var destination_units = [];

      //
      // reset on-chit-ui if no moved units
      //
      if (moved_units.length == 0) {
        this.fade_out_available_units = false;
        document.querySelectorAll('.army_tile').forEach(function (el) {
          if (el.classList.contains('nonopaque')) {
            el.classList.remove('nonopaque');
            el.classList.add('opaque');
          }
        });
      }
      var s = destination;
      try {
        if (this.mod.game.spaces[s]) {
          s = this.mod.game.spaces[s];
        }
      } catch (err) {}
      for (var key in s.units) {
        if (his_self.returnPlayerCommandingFaction(key) == faction) {
          for (var i = 0; i < s.units[key].length; i++) {
            if (s.units[key][i].land_or_sea === 'land' || s.units[key][i].land_or_sea === 'both') {
              destination_units.push({
                faction: key,
                idx: i,
                type: s.units[key][i].type
              });
            }
          }
        }
      }
      var obj = {
        faction: faction,
        moved_units: moved_units,
        unmoved_units: unmoved_units,
        destination_units: destination_units,
        space: space,
        from: from,
        to: to,
        max_formation_size: max_formation_size,
        units_to_move: units_to_move,
        selectUnitsInterface: selectUnitsInterface,
        selectDestinationInterface: selectDestinationInterface
      };
      this.mod.available_units_overlay.hide();
      this.overlay.show(MovementOverlayTemplate(obj, this.mod));
      this.mod.available_units_overlay.renderMove(mobj, faction, space.key);
      if (this.fade_out_available_units) {
        this.mod.available_units_overlay.fadeOut();
      }
      this.pushHudUnderOverlay();
      this.attachEvents(obj);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(obj) {
      var _this = this;
      var his_self = this.mod;
      var units_to_move = obj.units_to_move || [];
      var space = obj.space;
      document.querySelectorAll('.movement-overlay .movement-unit.option').forEach(function (el) {
        el.onclick = function (e) {
          e.stopPropagation();
          var parts = e.currentTarget.id.split('-');
          var faction = parts[0];
          var idx = parseInt(parts[1], 10);
          if (!faction || Number.isNaN(idx)) {
            return;
          }
          var selected = -1;
          for (var z = 0; z < units_to_move.length; z++) {
            if (units_to_move[z].faction === faction && parseInt(units_to_move[z].idx, 10) === idx) {
              selected = z;
              break;
            }
          }
          if (_this.factionIsOverCapacity(faction)) {
            alert('This faction is over-capacity (no more free 1-UNIT tokens). Please move by clicking on the circular tokens you wish to move instead of shifting forces in 1-UNIT increments');
            return;
          }
          if (selected >= 0) {
            units_to_move.splice(selected, 1);
            if (units_to_move.length == 0) {
              his_self.available_units_overlay.faded_out = false;
              _this.fade_out_available_units = false;
            }
          } else {
            var unitno = 0;
            for (var i = 0; i < units_to_move.length; i++) {
              var selected_unit = space.units[units_to_move[i].faction] && space.units[units_to_move[i].faction][units_to_move[i].idx];
              if (selected_unit && selected_unit.command_value == 0) {
                unitno++;
              }
            }
            var max_formation_size = obj.max_formation_size;
            if (unitno >= max_formation_size) {
              max_formation_size = his_self.returnMaxFormationSize(units_to_move, obj.faction, space.key);
              if (unitno >= max_formation_size) {
                alert('Maximum Formation Size: ' + max_formation_size);
                return;
              }
            }
            var entry = _this.findColumnUnit(obj, faction, idx);
            var unit = space.units[faction] && space.units[faction][idx];
            units_to_move.push(entry || {
              faction: faction,
              idx: idx,
              type: unit ? unit.type : '',
              spacekey: space.key
            });
          }
          if (typeof _this.selectUnitsInterface === 'function') {
            _this.selectUnitsInterface(his_self, units_to_move, _this.selectUnitsInterface, _this.selectDestinationInterface);
          }
        };
      });
      var submit = document.querySelector('.movement-overlay .movement-submit-button');
      if (submit) {
        submit.onclick = function (e) {
          e.stopPropagation();
          _this.hide();
          if (typeof _this.selectDestinationInterface === 'function') {
            _this.selectDestinationInterface(his_self, units_to_move);
          }
        };
      }
    }
  }, {
    key: "factionIsOverCapacity",
    value: function factionIsOverCapacity(faction) {
      try {
        var on_board = this.mod.returnOnBoardUnits(faction);
        return !!(on_board && on_board.overcapacity == 1);
      } catch (err) {
        return false;
      }
    }
  }, {
    key: "findColumnUnit",
    value: function findColumnUnit(obj, faction, idx) {
      var lists = [obj.unmoved_units || [], obj.moved_units || []];
      for (var i = 0; i < lists.length; i++) {
        for (var z = 0; z < lists[i].length; z++) {
          if (lists[i][z].faction === faction && parseInt(lists[i][z].idx, 10) === idx) {
            return JSON.parse(JSON.stringify(lists[i][z]));
          }
        }
      }
      return null;
    }
  }]);
}();
module.exports = MovementOverlay;